import React from "react";
import ButtonNav from "components/Design/Button/NavButton";
import { useI18next, useTranslation } from "gatsby-plugin-react-i18next";
import supportLinks from "dictionaries/supportLinks";

function ReachUs({ supportReachUsLink }) {
  const { t } = useTranslation(["homepage", "support"]);
  const { language } = useI18next();

  const links = supportLinks();
  const { label, icon } = links[language];

  return (
    <ButtonNav href={supportReachUsLink} prefixIcon={icon} label={t(label)} />
  );
}

export default ReachUs;
